export function fromStringToBase64(str) {
    const bytes = new TextEncoder().encode(str);
    const binary = String.fromCharCode(...bytes);
    return window.btoa(binary);
}

export function fromBase64ToString(base64: string): string {
    const binary = window.atob(base64);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}